import type { AdapterMeta } from "@repo/adapter-core";

export const DOMAIN_ADAPTER_META: AdapterMeta = {
  slug: "domain-com-au",
  name: "Domain.com.au",
  baseUrl: "https://www.domain.com.au",
  description: "Australian property listings from Domain.",
  supportedStates: ["ACT", "NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA"],
  urlPattern: /domain\.com\.au\/[a-z0-9-]+-\d{7,}$/i,
  sourceType: "portal",
};
